import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { CustomSetting } from '@/core/api/entities/misc/customSetting'
import { CustomSettingMapper } from '@/core/api/mappers/misc/customSettingMapper'
import miscService from '@/core/api/services/miscService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

/**
 * Hook to fetch custom settings for partner customization
 */
export const useCustomSettings = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<CustomSetting | null, Error> => {
	return useQuery({
		queryKey: ['custom-settings'],
		queryFn: () =>
			miscService
				.getCustomSettings(config)
				.then(({ data: response }) => {
					return response?.data
						? CustomSettingMapper.toEntity(response.data)
						: null
				})
				.catch((error) => {
					console.error('Error fetching custom settings:', error)
					return null
				}),
		// Retry up to 3 times with exponential backoff
		retry: 3,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}

/**
 * Hook to fetch custom CSS for partner customization
 */
export const useCustomCSS = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<string, Error> => {
	return useQuery({
		queryKey: ['custom-css'],
		queryFn: () =>
			miscService
				.getCustomCSS(config)
				.then(({ data: response }) => {
					return response.data || ''
				})
				.catch((error) => {
					console.error('Error fetching custom CSS:', error)
					return ''
				}),
		// Retry up to 3 times with exponential backoff
		retry: 3,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
